import React from 'react';

interface StatusBadgeAssessCompleteProps {
  label: string;
  badgeStyle: React.CSSProperties;
}

// TODO: remove this component once mastodon is updated in candidate-portal.
// mastodon v3.20.2 does not provide an icon for the Complete status badge,
// necessitating this component as an override
const StatusBadgeAssessComplete: React.FC<StatusBadgeAssessCompleteProps> = ({
  label,
  badgeStyle,
}) => {
  const style = {
    ...badgeStyle,
    backgroundColor: '#e8f0f9',
  };

  return (
    <span
      data-testid='status-badge-assess-complete'
      className='mastodon-status-badge assess complete'
      style={style}
    >
      <div
        className='mastodon-status-icon status-icon-complete'
        style={{ position: 'absolute', backgroundColor: '#d1e4f8' }}
      >
        <svg
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='iconClearEligibleComplete'>
            <g id='vector'>
              <path
                id='Vector'
                fill='#023161'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.5303 5.46967C11.8232 5.76256 11.8232 6.23744 11.5303 6.53033L7.53033 10.5303C7.23744 10.8232 6.76256 10.8232 6.46967 10.5303L4.46967 8.53033C4.17678 8.23744 4.17678 7.76256 4.46967 7.46967C4.76256 7.17678 5.23744 7.17678 5.53033 7.46967L7 8.93934L10.4697 5.46967C10.7626 5.17678 11.2374 5.17678 11.5303 5.46967Z'
              />
            </g>
          </g>
        </svg>
      </div>
      {label}
    </span>
  );
};

export default StatusBadgeAssessComplete;
